import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";

const Profil = () => {
  const { utilisateur } = useAuth();
  const [form, setForm] = useState({ ancien_mdp: "", nouveau_mdp: "", confirmer_mdp: "" });
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    if (form.nouveau_mdp !== form.confirmer_mdp) {
      setError("Les nouveaux mots de passe ne correspondent pas");
      return;
    }
    if (form.nouveau_mdp.length < 6) {
      setError("Le nouveau mot de passe doit contenir au moins 6 caractères");
      return;
    }

    setLoading(true);
    try {
      await api.put("/auth/changer-mdp", {
        ancien_mot_de_passe: form.ancien_mdp,
        nouveau_mot_de_passe: form.nouveau_mdp,
      });
      setSuccessMsg("Mot de passe modifié avec succès !");
      setForm({ ancien_mdp: "", nouveau_mdp: "", confirmer_mdp: "" });
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors du changement de mot de passe");
    } finally {
      setLoading(false);
    }
  };

  const roleColor = {
    "Commercial": "#185FA5",
    "Superviseur": "#0f6e56",
    "Administrateur": "#7c3aed",
  };

  const roleBg = {
    "Commercial": "#E6F1FB",
    "Superviseur": "#E1F5EE",
    "Administrateur": "#f3e8ff",
  };

  const initiales = utilisateur
    ? `${utilisateur.nom?.charAt(0) || ""}${utilisateur.prenom?.charAt(0) || ""}`
    : "??";

  const color = roleColor[utilisateur?.role] || "#185FA5";
  const bg = roleBg[utilisateur?.role] || "#E6F1FB";

  return (
    <div style={{ maxWidth: "500px", margin: "0 auto", padding: "1.5rem" }}>
      {/* Header profil */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.5rem", marginBottom: "1.25rem", display: "flex", alignItems: "center", gap: "1rem" }}>
        <div style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px", fontWeight: "500", color, flexShrink: 0 }}>
          {initiales}
        </div>
        <div>
          <div style={{ fontSize: "16px", fontWeight: "500", color: "#111827" }}>
            {utilisateur?.prenom} {utilisateur?.nom}
          </div>
          <div style={{ fontSize: "13px", color: "#6b7280", marginTop: "2px" }}>{utilisateur?.email}</div>
          <span style={{ fontSize: "11px", padding: "2px 8px", borderRadius: "6px", backgroundColor: bg, color, marginTop: "4px", display: "inline-block", fontWeight: "500" }}>
            {utilisateur?.role}
          </span>
        </div>
      </div>

      {/* Formulaire changement mot de passe */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.5rem" }}>
        <h2 style={{ fontSize: "15px", fontWeight: "500", color: "#111827", margin: "0 0 1.25rem" }}>
          Changer le mot de passe
        </h2>

        {successMsg && (
          <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", color: "#16a34a", fontSize: "13px" }}>
            {successMsg}
          </div>
        )}
        {error && (
          <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {[
            { label: "Mot de passe actuel", key: "ancien_mdp", placeholder: "••••••••" },
            { label: "Nouveau mot de passe", key: "nouveau_mdp", placeholder: "Min. 6 caractères" },
            { label: "Confirmer le nouveau mot de passe", key: "confirmer_mdp", placeholder: "••••••••" },
          ].map(({ label, key, placeholder }) => (
            <div key={key} style={{ marginBottom: "1rem" }}>
              <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>{label} *</label>
              <input
                type="password"
                value={form[key]}
                onChange={e => setForm({ ...form, [key]: e.target.value })}
                placeholder={placeholder}
                required
                style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", color: "#111827", outline: "none", boxSizing: "border-box", background: "white" }}
              />
            </div>
          ))}

          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: `linear-gradient(135deg, ${color}, ${color}cc)`, color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1, marginTop: "0.5rem" }}>
            {loading ? "Modification..." : "Modifier le mot de passe"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profil;